import { AddItemToBasketRequest } from './AddItemToBasketRequest';

export interface ValidatedBasket {
  productID: number;
  quantity: number;
  optionValueIDs: string[];
}

export const validatedBasketFromResponse = (
  responseData: any,
): ValidatedBasket => ({
  productID: responseData.product_id,
  quantity: responseData.quantity,
  optionValueIDs: responseData.option_value_ids ?? [],
});

export const validatedBasketToAddItemRequest = (
  validatedBasket: ValidatedBasket,
): AddItemToBasketRequest => ({
  productID: validatedBasket.productID,
  quantity: validatedBasket.quantity,
  optionValueID: validatedBasket.optionValueIDs[0],
});
